var _rect, _path, _rect2, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _rect8, _rect9, _path3, _rect10, _rect11, _rect12, _rect13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconDocs = function SvgIconDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 5,
    fill: "#7666FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4127 13.7696L4.87178 17.6658C3.28574 18.0908 2.27746 19.4708 2.61972 20.7481L8.10958 41.2366C8.45184 42.5139 10.015 43.2049 11.6011 42.7799L26.142 38.8837C27.728 38.4587 28.7363 37.0787 28.394 35.8014L22.9042 15.3129C22.5619 14.0356 20.9987 13.3446 19.4127 13.7696Z",
    fill: "#C868EC",
    stroke: "#1B192C",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.19189,
    y: 22.4885,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-15 6.19189 22.4885)",
    fill: "#1B192C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.35669,
    y: 26.8352,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-15 7.35669 26.8352)",
    fill: "#1B192C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.52124,
    y: 31.1819,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-15 8.52124 31.1819)",
    fill: "#1B192C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.68604,
    y: 35.5286,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-15 9.68604 35.5286)",
    fill: "#1B192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1419 6.66571L25.601 2.76949C24.015 2.34451 22.4518 3.03548 22.1095 4.31282L16.6197 24.8012C16.2774 26.0786 17.2857 27.4586 18.8717 27.8836L33.4126 31.7798C34.9987 32.2048 36.5619 31.5138 36.9041 30.2364L42.394 9.74802C42.7362 8.47068 41.728 7.09069 40.1419 6.66571Z",
    fill: "#5BA0E0",
    stroke: "#1B192C",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.333,
    y: 7.6062,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(15 24.333 7.6062)",
    fill: "#1B192C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1682,
    y: 11.9529,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(15 23.1682 11.9529)",
    fill: "#1B192C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0037,
    y: 16.2996,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(15 22.0037 16.2996)",
    fill: "#1B192C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8389,
    y: 20.6462,
    width: 15,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(15 20.8389 20.6462)",
    fill: "#1B192C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0269 11.2747H15.9731C14.3311 11.2747 13 12.3467 13 13.6691V34.8802C13 36.2026 14.3311 37.2747 15.9731 37.2747H31.0269C32.6689 37.2747 34 36.2026 34 34.8802V13.6691C34 12.3467 32.6689 11.2747 31.0269 11.2747Z",
    fill: "#F0CD4E",
    stroke: "#1B192C",
    strokeMiterlimit: 10
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.2747,
    width: 15,
    height: 2.5,
    rx: 1.25,
    fill: "#1B192C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20.7747,
    width: 15,
    height: 2.5,
    rx: 1.25,
    fill: "#1B192C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25.2747,
    width: 15,
    height: 2.5,
    rx: 1.25,
    fill: "#1B192C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29.7747,
    width: 15,
    height: 2.5,
    rx: 1.25,
    fill: "#1B192C"
  })));
};

export { SvgIconDocs as ReactComponent };
export default "data:image/svg+xml;base64,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";